import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { ReactComponent as EmptyStateIcon } from 'src/assets/images/emptyState.svg';
import { Keys, locale } from 'src/i18n';
import styles from '../index.module.scss';

function EmptyState({ message }: { message?: string }) {
  return (
    <div className={styles.emptyState}>
      <EmptyStateIcon />
      <Text type="h6">{locale(Keys.NO_RESULTS_TO_SHOW)}</Text>
      {message && <Text>{message}</Text>}
    </div>
  );
}
export default EmptyState;
